import { IPOStyleMixins } from "../../styles";
import styled, { css } from "styled-components";

export function popoverStyle() {
	return css`
		& div[class*="ant-popover-placement"] {

      & .ant-popover-arrow {
        display: none;
      }

      & .ant-popover-content {
        background: #FFFFFF;
        box-shadow: 5px 2px 10px 0px rgba(43,45,57,0.2000);

        padding: 0 10px;

        & .ant-popover-inner-content {
          padding: 0;
        }

        & .ant-popover-inner {
          background: unset;
          background-color: unset;
          background-clip: unset;
          border-radius: unset;
          box-shadow: unset;
        }
      }
    }
	`;
}

export function avatarStyle() {
	return css`
    & .ant-avatar {
      cursor: pointer;
    }
	`;
}

export function popoverNoPaddingStyle() {
  return css`
    & .ant-popover-content {
      padding: 0 !important;
    }
  `
}

export function projectChangeShowStyle() {
  return css`
    .selected-name {
      ${IPOStyleMixins.flex('row', 'flex-start', 'center')};
    }
  `
}

export const UserMenuWrap = styled.div`
  
  > .menus {
    padding: 5px 0;
    border-bottom: 1px solid #EBECF0;

    > .menu-item {
      width: 100%;
      height: 28px;
      border-radius: 2px;
      line-height: 28px;
      cursor: pointer;
      margin-top: 5px;
      padding: 0 10px;
      ${IPOStyleMixins.flex('row', 'flex-start', 'center')};
      word-break: keep-all;

      :hover {
        background: #F4F5F7;
      }

      & img {
        margin-right: 5px;
      }

      & .ant-popover-placement-left {
        left: -130px !important;

        & .ant-popover-content {
          background: #FFFFFF;
          box-shadow: 0px 3px 8px 0px rgba(23,43,77,0.1800);
          border-radius: 4px;
          border: 1px solid #DFE1E6;
        }
      }
    }
  }

  > .logout {
    cursor: pointer;
    padding: 10px;
    > img {
      margin-right: 5px;
    }
  }
`

export const MsgWrap = styled.div`
  width: 100px;
  padding: 10px 0;
  > .msg-item {
    padding: 0 10px;
    height: 28px;
    line-height: 28px;
    cursor: pointer;
    background: #ffffff;

    :hover {
      background: #F4F5F7;
    }
  }
`

/**
 * 横版
 */
export const UserHeaderTopWrap = styled.div`
  width: 100%;
  background-color: rebeccapurple;
  height: 40px;
  padding: 0 30px;
  ${IPOStyleMixins.flex('row', 'space-between', 'center')};

  > .left {
    & .home-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #DFECFF;
    }

    ${projectChangeShowStyle()};

    & .selected-name {
      margin-left: 5px;
      margin-right: 5px;

      ${popoverNoPaddingStyle()};
    }
  }

  > .right {
    ${IPOStyleMixins.flex('row', 'flex-end', 'center')};
    ${popoverStyle()};
    & .nav-item {
      ${avatarStyle()};
      ${popoverStyle()};
      ${popoverNoPaddingStyle()}
      & .ant-popover-placement-bottomRight,
      & .ant-popover-placement-bottomLeft,
      & .ant-popover-placement-bottom {
        top: 24px !important;
      }
    }

    & .header-chat {
      margin-right: 20px;
    }
  }
`

/**
 * 这是竖版
 */
export const UserHeaderLeftWrap = styled.div`
  ${IPOStyleMixins.flex('column', 'flex', 'center')};
  ${popoverStyle()};

  background-color: cadetblue;
  width: 60px;
  height: 100vh;
  padding: 30px 15px;

  & .nav-item {
    ${avatarStyle()};
    ${popoverNoPaddingStyle()};

  }

  & .header-chat {
    margin-top: 20px;
  }
`

export const UnreadWrap = styled.div`
  .group-item {
    width: 100%;
    ${IPOStyleMixins.flex('row', 'flex-start', 'flex-start')}
    box-sizing: border-box;
    padding: 14px 10px 14px 12px;
    cursor: pointer;
    .title {
      font-size: 12px;
      font-weight: 400;
      color: #172b4d;
      line-height: 17px;
      display: inline-block;
      white-space: nowrap;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .group-item-right {
      flex: 1 1 auto;
      overflow: hidden;
      .node-text {
        font-size: 12px;
        color: #a9adba;
      }
      .group-item-title-node {
        display: flex;
        align-items: center;
      }
      .group-item-unread {
        width: 16px;
        height: 16px;
        background: #ff4545;
        border-radius: 50%;
        font-size: 12px;
        color: #fff;
        text-align: center;
      }
    }
    &.actice {
      background-color: #dfecff;
    }
    &-left {
      width: 34px;
      height: 100%;
      flex: 0 0 auto;
      ${IPOStyleMixins.flex('row', 'flex-start', 'center')}
    }
    &-right {
      flex: 1 1 auto;
      height: 100%;
      box-sizing: border-box;
      padding: 0 10px;
      &-top {
        height: 50%;
        ${IPOStyleMixins.flex('row', 'space-between', 'center')}
        font-size: 12px;
        color: #a9adba;
        margin-bottom: 6px;
        > .group-item-title-node {
          overflow: hidden;
          flex: 1 1 auto;
          ${IPOStyleMixins.flex('row', 'flex-start', 'center')}
          > .group-name {
            font-size: 12px;
            color: #172b4d;
            ${IPOStyleMixins.ellipsis()}
          }
          > .group-work-name {
            overflow: hidden;
            ${IPOStyleMixins.flex('row', 'flex-start', 'center')}
            > span {
              overflow: hidden;
              flex-shrink: 1;
              ${IPOStyleMixins.ellipsis()}
            }
          }
        }
        > .group-last-time {
          flex: 0 0 auto;
        }
      }
      &-bottom {
        height: 50%;
        ${IPOStyleMixins.flex('row', 'flex-start', 'center')}
        font-size: 12px;
        color: #6c788c;
        > .message-text {
          overflow: hidden;
          flex: 1 1 auto;
          ${IPOStyleMixins.flex('row', 'flex-start', 'center')}
          > .message-sender-name {
            ${IPOStyleMixins.flex('row', 'flex-start', 'center')}
            flex-shrink: 0;
            ${IPOStyleMixins.ellipsis()}
          }
          > .text {
            ${IPOStyleMixins.ellipsis()}
          }
          .name-wrap {
            font-size: 12px;
            color: #6c788c;
          }
        }
        > .group-item-unread {
          flex: 0 0 auto;
        }
      }
    }
  }
`